
  import createMeisterIcons from '../src/createMeisterIcons';

  const ParaAdd = createMeisterIcons("para-add", [["path",{"fill":"currentColor","d":"M3.75 4.25a.75.75 0 0 0 0 1.5h15a.75.75 0 0 0 0-1.5zm0 4a.75.75 0 0 0 0 1.5h15a.75.75 0 0 0 0-1.5zM3 13a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 0 1.5h-7A.75.75 0 0 1 3 13m.75 3.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5zm13.5-4A.75.75 0 0 1 18 13v2.25h2.25a.75.75 0 0 1 0 1.5H18V19a.75.75 0 0 1-1.5 0v-2.25h-2.25a.75.75 0 0 1 0-1.5h2.25V13a.75.75 0 0 1 .75-.75","key":"c6cc1f4e6abf83104c33adc7f11da83040b2ec40","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default ParaAdd
  